<template>
  <div class="introduction-template" theme>
    <div id="introduction-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'introduction',
      parts: [
        {
          elem: '#introduction-content',
          htmlFile: 'introduce'
        }
      ]
    }
  }
}
</script>
